import xss from 'xss';

import { ROUTER_BASENAME } from './dev-console/path-prefixes';
import { getBundleOverride } from './shared-components/bundle-override/build';

const FLAG_OVERRIDE_LOADED = 'bundleOverrideLoaded';

export function maybeBundleOverride(): boolean {
  // If we're being bootstrapped by DAC (because the CSRF meta tag exists) then we shouldn't handle bundle override ourselves
  const isDacBundleOverride = Boolean(document.querySelector('meta[name="csrf"]'));
  const isLocalBundleOverride = Boolean(document.querySelector(`meta[name="${FLAG_OVERRIDE_LOADED}"]`));
  const isBundleOverrideLoaded = isDacBundleOverride || isLocalBundleOverride;
  const bundleOverrideUrl = getBundleOverride(location.search);

  if (isLocalBundleOverride) {
    cleanupBundleOverrideLoader();
    injectBundleOverrideMarker();
  } else if (!isBundleOverrideLoaded && bundleOverrideUrl) {
    injectBundleOverride(bundleOverrideUrl);
    return true;
  }
  return false;
}

function injectBundleOverride(bundleOverride: string) {
  const override = validateBundleOverride(bundleOverride);

  // Prevent recursion by setting a flag so bundle override has occurred
  const flag = document.createElement('meta');
  flag.name = FLAG_OVERRIDE_LOADED;
  document.head.appendChild(flag);

  // Inject JS and CSS from bundle override
  const script = document.createElement('script');
  script.src = joinUrl(override, 'dev-console.bundle.js');
  script.dataset[FLAG_OVERRIDE_LOADED] = '1';
  document.head.appendChild(script);
}

/**
 * We can clean up the script and style that has been replaced by the bundle override
 */
function cleanupBundleOverrideLoader() {
  // Could be multiple due to chunk splitting
  document.querySelectorAll(`script[src^="${ROUTER_BASENAME}/assets/"]`).forEach((script) => script.remove());
}

function injectBundleOverrideMarker() {
  const marker = document.createElement('div');
  document.body.appendChild(marker);
  marker.outerHTML = `
    <div
      style="
        position: fixed;
        bottom: 0;
        right: 0;
        background: red;
        padding: 5px;
        color: white;
      "
    >
      Local bundle in use!
      <a href="http://go/dc-rocket" target="_blank" rel="noopener noreferrer">
        go/dc-rocket
      </a>
    </div>`;
}

function validateBundleOverride(bundleOverride: string) {
  const url = new URL(xss(bundleOverride));
  // Check that the page's URL allows bundle overrides
  const isLocalStaging = [
    'localhost',
    'developer.stg.atlassian-us-gov-mod.com',
    'developer.stg.internal.atlassian.com',
  ].includes(location.hostname);

  // Check that the bundle override script's URL is allowed
  const { hostname } = url;
  const isValidHost =
    hostname === 'localhost' ||
    hostname === 'host.docker.internal' ||
    hostname.endsWith('.atlastunnel.com') ||
    hostname.endsWith('.atl-paas.net');
  const validBundleOverride = isLocalStaging && isValidHost;
  if (!validBundleOverride) {
    throw new Error(`Bundle override URL is not allowed.`);
  }
  return url.toString();
}

function joinUrl(base: string, path: string): string {
  return `${base}${base.endsWith('/') ? '' : '/'}${path}`;
}
